import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import language from '../../assets/languages/language';
import { fetchCartItem } from './service';
import AppRoutes from '../../views/config/AppRoutes';

export default class HeaderCart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      count: '',
    };
  }
  componentDidMount = async () => {
    this.getCartItem();
  };

  shoppingCart = () => {
    browserHistory.push({
      pathname: AppRoutes.CART,
    });
  };

  async componentDidUpdate(prevProps) {
    const { setIsChildChangedFalse, pathname, isChildChanged } = this.props;
    if (
      (pathname === AppRoutes.CART || pathname.includes('thankyou')) &&
      (isChildChanged || prevProps.pathname !== pathname)
    ) {
      this.getCartItem();
      setIsChildChangedFalse();
    }
  }

  getCartItem = async data => {
    const resp = await fetchCartItem();
    if (resp.success) {
      if (resp.user_cart.length === 0) {
        this.setState({ count: '' });
      } else {
        this.setState({ count: resp.user_cart.length });
      }
    }
  };

  render() {
    const { count } = this.state;
    const itemCount = typeof count === 'number' ? count : 0;
    const cartLabel = itemCount === 1
      ? 'Shopping cart, 1 item'
      : `Shopping cart, ${itemCount} items`;
    const handleKeyDown = (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.shoppingCart();
      }
    };

    return (
      <li className='cart_li_wrap'>
        <a
          className='pointer_class cart-link'
          role='button'
          tabIndex={0}
          aria-label={cartLabel}
          onClick={this.shoppingCart}
          onKeyDown={handleKeyDown}
        >
          <p className='hidden-sm-down'>{language.LC().CART}</p>
          <div className='cart-section'>
            <i className='fa fa-shopping-cart fa-lg ' aria-hidden='true' />
            <span className='badge badge-pill badge-danger' aria-hidden='true'>
              {count}
            </span>
          </div>
        </a>
      </li>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Header/HeaderCart.jsx